// 1. 외부 패키지
import { useState } from "react";
import { useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom'

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import {
	getQuery,
	loginRead,
	getLoginRedirectUrl,
	apiCallback,
	errorAlert,
	errorGenerator,
} from '../../shared/function'
import get_basic_detail_selector from '../../selector/get-basic-detail-selector';
import accountManager from '../../shared/account-manager';
import API from '../../service/api'

// 4. 타입



const LeftBookMarker = () => {

	const idx = getQuery().idx;

	const data = useRecoilValue(get_basic_detail_selector(idx));

	const { fave_yn } = data.personal;

	const { push } = useHistory();

	const [fave, setFave] = useState<boolean>(fave_yn === 'Y');

	const onChangeFave = () => {
		if(accountManager.isGuest()) { 
			loginRead(() => {
				push(getLoginRedirectUrl());
			});
			return;
		}
		
		API.estate
			.setBookMark({
				estate_idx: parseInt(idx),
			})
			.then((res) => {
				apiCallback(res, {
					success: onChangeFaveSuccessCallback,
					fail: onChangeFaveFailCallback,
				});
			})
			.catch(onChangeFaveFailCallback);
	};

	const onChangeFaveSuccessCallback = () => {
    setFave(!fave);
  };

	const onChangeFaveFailCallback = () => {
		errorAlert(errorGenerator('보관하기 중 오류가 발생했습니다.'));
	};

	return (
		<div className='bookmark'>
			<input
				type='checkbox'
				id='_bookmark1'
				name='_bookmark'
				checked={fave}
				onChange={onChangeFave}
				/>
			<label htmlFor='_bookmark1' />
		</div>
	);
}

export default LeftBookMarker;